<template>
  <div>
    <div style="margin-bottom: 3px">
      注文書番号:
      <a
        target="_blank"
        style="color: #408d7c; text-decoration: underline"
        :href="'https://www.rakumart.com/api/ordno.php?type=3&ordno=' + ordno"
      >
        {{ ordno }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },

  data() {
    return {};
  },
  computed: {
    ordno() {
      return JSON.parse(this.message.payload.description).order;
    },
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>